import { Checkbox, Form, FormItemProps } from 'antd';
import { FC } from 'react';

import './styles.scss';

interface FormItemCheckboxPropsType extends FormItemProps {
  label: React.ReactNode;
  subLabel?: React.ReactNode;
  description?: string;
  name: string;
}

const FormItemCheckbox: FC<FormItemCheckboxPropsType> = (props) => {
  const { label, subLabel, description, name } = props;
  return (
    <Form.Item
      {...props}
      valuePropName="checked"
      name={name}
      tooltip={description}
      className="form__item-checkbox"
      label={
        <div className="item-checkbox__label">
          <span>{label}</span>
          {subLabel && <span className="label__subtitle">{subLabel}</span>}
        </div>
      }
    >
      <Checkbox />
    </Form.Item>
  );
};

export default FormItemCheckbox;
